import React, { SVGProps } from 'react';

const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
        <rect width={10.435} height={10.435} x={9.422} y={3.929} stroke="#111" strokeLinejoin="round" strokeWidth={1.5} rx={1} />
        <path
            fill="#111"
            fillRule="evenodd"
            d="M6.441 9.391H4.46a1.5 1.5 0 0 0-1.5 1.5v8.435a1.5 1.5 0 0 0 1.5 1.5h8.434a1.5 1.5 0 0 0 1.5-1.5v-1.981h-1v1.981a.5.5 0 0 1-.5.5H4.46a.5.5 0 0 1-.5-.5v-8.435a.5.5 0 0 1 .5-.5H6.44v-1Z"
            clipRule="evenodd"
        />
    </svg>
);

export default CopyIcon;
